module.exports = __webpack_public_path__ + "img/reliable-1.4a933615.png";